import React from "react";

const MandatoryCell = () => {

    return (
        <div
            className="tw-flex tw-h-[80px] tw-p-3 tw-flex-col tw-justify-center tw-items-start tw-gap-2 tw-self-stretch tw-border-b tw-border-solid tw-border-mutelios-blue-light">
                            <span
                                className="tw-text-body-lead-bold tw-text-mutelios-txt-color">Contrat obligatoire</span>
            <img src="/o/mutelios-theme-css/icons/RectangleBleu.svg" alt=""/>
        </div>
    );
}

export default MandatoryCell;
